import React, { Fragment, useMemo, useReducer, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { dataToSendReducer } from './show-note-forms/dataToSendReducer';
import GlobalNoteDialogFormField from './show-note-forms/GlobalNoteDialogFormField';
import CustomDialog from './CustomDialog';
import CustomDialogButtonsContainer from './CustomDialogButtonsContainer';

interface Props {
    formsData: { [key: string]: any };
    formsOrigin: { data: any; order: number }[];
    typeNote?: any;
}

const ShowNoteForms: React.FC<Props> = ({ formsOrigin, formsData }) => {
    const translate = useTranslate();
    const [open, setOpen] = useState(false);

    const dataToSendInitialState = useMemo(() => {
        const output: any = { forms: {} };

        formsOrigin.forEach((form, index) => {
            const keyToSelect = form.data.id in formsData ? form.data.id : form.data.name;

            if (keyToSelect in formsData) {
                output.forms[index] = {
                    toSend: {
                        [keyToSelect]: formsData[keyToSelect],
                    },
                    required: false,
                    valid: true,
                };
            }
        });

        return output;
    }, [formsOrigin, formsData]);

    const [dataToSendState, dataToSendStateDispatch] = useReducer(dataToSendReducer as any, dataToSendInitialState);

    const stepsComponents = useMemo(() => {
        const output: { order: number; required: boolean; index: number; component: any; key: 'forms' }[] = [];

        formsOrigin.forEach((form, index) => {
            const required = form?.data?.required ?? false;
            const formId = form.data.id in formsData ? form.data.id : form.data.name;

            if (formId in formsData) {
                output.push({
                    order: form.order,
                    required,
                    index,
                    key: 'forms',
                    component: (
                        <GlobalNoteDialogFormField
                            required={required}
                            nodeForm={form}
                            formId={formId}
                            dataToSendState={dataToSendState}
                            dataToSendStateDispatch={dataToSendStateDispatch}
                            index={String(index)}
                            key={form.order}
                            readOnly={true}
                        />
                    ),
                });
            }
        });

        return output;
    }, [formsOrigin, formsData, dataToSendState]);

    // Hide the button/dialog if there are no resolvable forms (parity with intent of platform-v2 UX)
    if (!formsData || (Array.isArray(formsOrigin) && formsOrigin.length === 0) || stepsComponents.length === 0)
        return null;

    return (
        <Fragment>
            <Button
                onClick={() => setOpen(true)}
                variant='outlined'
                color='primary'
                style={{ marginLeft: 8, marginRight: 8, boxShadow: 'none' }}
            >
                {translate('app.main_buttons.openForms')}
            </Button>

            <CustomDialog
                open={open}
                onClose={() => setOpen(false)}
                withBackdrop={false}
                title={translate('app.notes.formsDialog')}
            >
                <Box
                    style={{
                        display: 'grid',
                        gap: 8,
                        padding: 8,
                        margin: 8,
                        marginBottom: 0,
                        borderRadius: 8,
                        background: '#F1F1F1',
                    }}
                >
                    {stepsComponents.map((step) => step.component)}
                </Box>

                <CustomDialogButtonsContainer>
                    <Button color='primary' onClick={() => setOpen(false)}>{translate('ra.action.close')}</Button>
                </CustomDialogButtonsContainer>
            </CustomDialog>
        </Fragment>
    );
};

export default ShowNoteForms;
